import axios from "axios";
import i18n from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers = config.headers || {};
  config.headers["Accept-Language"] = i18n.language || "it";
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Returns the JWT auth token. Centralised so we can later swap the storage
 * backend (e.g. HttpOnly cookie) without touching every caller.
 * Only the JWT lives in localStorage — no PII is ever stored here.
 */
export function getAuthToken() {
  try { return localStorage.getItem("sr_token"); } catch { return null; }
}

/** Authorization header convenience for raw `fetch()` calls (PDF downloads, file uploads). */
export function authHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default api;
